import React, {useRef, useState} from 'react';
import Slider from 'react-slick';
import {useWindowSize} from '../../hooks/useWindowSize';
import CarouselIndicator from '../CarouselIndicator';
import styled, {css} from 'styled-components';
import {useTranslation} from 'react-i18next';
import {ReactComponent as ArrowIcon} from '../../assets/dkids/carousel_arrow.svg';
import {mobileMediaQuery, notWebMediaQuery} from '../../styles';
import {Link} from 'react-router-dom';
import {debugCNitoUrl} from '../../helpers';
import {getCurrentLang} from '../../utils/i18n';

const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '25%',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '25%',
                slidesToShow: 1,
            },
        },
        {
            breakpoint: 600,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '32px',
                slidesToShow: 1,
            },
        },
    ],
};

const DKidsGamesCarousel = ({games}) => {
    const {width} = useWindowSize();
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const {t} = useTranslation();

    if (!width) {
        return null;
    }
    //calculate carousel height
    let cardWidth;
    if (width > 1024) {
        cardWidth = width / 1.8;
    } else if (width > 600) {
        cardWidth = width / 1.8;
    } else {
        cardWidth = width - 50;
    }

    let cardHeight = cardWidth * 0.56;
    let sliderHeight = cardWidth * 0.62 + 20;

    if (width < 600) {
        sliderHeight += 20;
    }

    let gamesCopy = [...games, ...games, ...games];

    const onAfterChange = index => setCurrentSlide(index % games.length);

    const handlePreviousSlide = () => {
        // eslint-disable-next-line no-unused-expressions
        sliderRef.current?.slickPrev();
    };

    const handleNextSlide = () => {
        // eslint-disable-next-line no-unused-expressions
        sliderRef.current?.slickNext();
    };

    const link = getCurrentLang() === 'es' ? 'juegos/' : 'jogos/';

    return (
        <HeaderContainer>
            <Slider
                {...settings}
                style={{height: sliderHeight}}
                ref={sliderRef}
                afterChange={onAfterChange}
            >
                {gamesCopy.map((game, index) => (
                    <div key={game.id}>
                        <HeaderImage
                            to={`${link}${game.slug}${debugCNitoUrl()}`}
                            url={game.image}
                            height={cardHeight}
                        />
                    </div>
                ))}
            </Slider>
            <CarouselIndicator
                selected={currentSlide}
                total={games.length}
                brand="dkids"
            />
            <LeftControls>
                <ButtonPrev disabled={false} onClick={handlePreviousSlide}>
                    <ArrowIcon title={t('controls.previous')} />
                </ButtonPrev>
            </LeftControls>

            <RightControls>
                <ButtonNext disabled={false} onClick={handleNextSlide}>
                    <ArrowIcon title={t('controls.next')} />
                </ButtonNext>
            </RightControls>
        </HeaderContainer>
    );
};

const HeaderImage = ({url, height, to}) => {
    return (
        <ImageContainer to={to}>
            <HeaderCover src={url} height={height} />
        </ImageContainer>
    );
};

const HeaderContainer = styled.div`
    align-items: center;
    width: 100%;
    justify-content: center;
    position: relative;

    margin-top: 16px;
    padding-bottom: 20px;

    ${mobileMediaQuery} {
        padding-bottom: 40px;
    }

    .slick-slide {
        -moz-transform: scale(0.9);
        -ms-transform: scale(0.9);
        -o-transform: scale(0.9);
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
        transition: all 300ms ease;
        opacity: 0.5;
    }

    .slick-center {
        -moz-transform: scale(1.08);
        -ms-transform: scale(1.08);
        -o-transform: scale(1.08);
        -webkit-transform: scale(1.08);
        transform: scale(1.08);
        transition: all 300ms ease;
        opacity: 1;
    }
`;

const HeaderCover = styled.img`
    height: ${props => props.height}px;
    margin: 16px 0;
    transition: all 0.2s';
    width: 99%;
    border-radius: 20px;
    overflow: hidden;
`;

const ImageContainer = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0px;
    overflow: hidden;
`;

const LeftControls = styled.div`
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translate(-50%, -50%);
    width: 0px;
    height: 0px;
    overflow: visible;
    z-index: 5;
`;

const RightControls = styled(LeftControls)`
    left: initial;
    right: 0px;
    transform: translate(-50%, -50%);
`;

const ButtonPrev = styled.button`
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 54px;
    height: 54px;
    border: none;
    border-radius: 27px;
    background-color: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    cursor: pointer;
    padding: 0px;

    margin: auto;
    left: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 6px;
    svg {
        width: 18px;
        height: 28px;
        transform: initial;

        margin: auto;
    }

    ${notWebMediaQuery} {
        display: none;
    }

    ${({disabled}) =>
        disabled &&
        css`
            cursor: initial;
            opacity: 0.65;
        `}
`;

const ButtonNext = styled(ButtonPrev)`
    padding-right: initial;
    padding-left: 6px;
    left: -46px;

    svg {
        transform: scaleX(-1);
    }
`;

export default DKidsGamesCarousel;
